module.exports = Aedu.User;